import { render, staticRenderFns } from "./DrawingBrushMenu.vue?vue&type=template&id=88b46f9e"
import script from "./DrawingBrushMenu.vue?vue&type=script&lang=js"
export * from "./DrawingBrushMenu.vue?vue&type=script&lang=js"
import style0 from "./DrawingBrushMenu.vue?vue&type=style&index=0&id=88b46f9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports